import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

declare module 'axios' {
  interface AxiosResponse<T = any> extends Promise<T> {}
}
export abstract class HttpClient {
  protected readonly instance: AxiosInstance;

  public constructor(baseURL: string, apikey: string) {
    this.instance = axios.create({
      baseURL,
      timeout: 30000,
      params: {
        apikey,
      },
    });

    this._initializeResponseInterceptor();
  }

  private _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError
    );
  };

  private _handleResponse = (response: AxiosResponse) => response;

  protected _handleError = (error: AxiosError) => Promise.reject(error);
}
